import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import { createPinia } from "pinia";
import InlineSvg from "vue-inline-svg";
import Toast from "vue-toastification";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
// import { VueReCaptcha } from "vue-recaptcha-v3";
import { Field, Form, ErrorMessage } from "vee-validate";
import { createHead } from "@unhead/vue";
import { definePreset } from "@primevue/themes";

import "virtual:uno.css";
import "vue-toastification/dist/index.css";

const pinia = createPinia();
const head = createHead();
const app = createApp(App);

const MyPreset = definePreset(Aura, {
	semantic: {
		primary: {
			50: "{blue.50}",
			100: "{blue.100}",
			200: "{blue.200}",
			300: "{blue.300}",
			400: "{blue.400}",
			500: "{blue.500}",
			600: "{blue.600}",
			700: "{blue.700}",
			800: "{blue.800}",
			900: "{blue.900}",
			950: "{blue.950}",
		},
	},
});

app.use(PrimeVue, {
	theme: {
		preset: MyPreset,
		options: {
			darkModeSelector: "none",
		},
	},
});
app.use(ToastService);
app.use(ConfirmationService);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(head);

app.component("InlineSvg", InlineSvg);
app.component("FieldComp", Field);
app.component("FormComp", Form);
app.component("ErrorMessage", ErrorMessage);

const options = {
	position: "top-right",
	timeout: 5000,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: true,
	closeButton: false,
	icon: false,
	rtl: false,
	toastClassName: "my-custom-toast-class",
};
app.use(Toast, options);
// if (import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY) {
// 	app.use(VueReCaptcha, {
// 		siteKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY,
// 		loaderOptions: {
// 			autoHideBadge: false,
// 		},
// 	});
// }

app.mount("#app");
